<template>
  <div ref="viewedExplanationObserver">
&#32;
  </div>
</template>

<script>
export default {
  props: {
    category: {
      type: Object,
      default: () => ({}),
    },
    correct: {
      type: Boolean,
      default: false,
    },
    flashcard: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      observer: null,
      hasIntersected: false,
      initialRenderTimeStamp: Date.now(),
    };
  },
  mounted() {
    const options = {
      root: null,
      rootMargin: '0px',
      threshold: 0.1,
    };

    this.observer = new IntersectionObserver(this.handleIntersection, options);

    if (this.$refs.viewedExplanationObserver) {
      this.observer.observe(this.$refs.viewedExplanationObserver);
    }
  },
  beforeUnmount() {
    if (this.observer) {
      this.observer.disconnect();
    }
  },
  methods: {
    handleIntersection(entries) {
      entries.forEach(entry => {
        if (entry.isIntersecting && !this.hasIntersected) {
          this.$analytics.events.viewedExplanation(
            this.flashcard,
            this.category,
            Date.now() - this.initialRenderTimeStamp,
            this.correct,
          );
          this.hasIntersected = true;
          this.observer.unobserve(entry.target);
        }
      });
    },
  },
};
</script>

<style scoped>
div {
  height: 2px;
}
</style>
